import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import Card from '../../../components/Card';
import { Button } from 'primereact/button';
import { postApiCall } from '../../../service/postApiCall';
import { getApiCall } from '../../../service/getApiCall';
import { AGENT_GROUP_CREATE, API_AGENT_UPDATE, API_AGENT_GROUP_EXTENSION } from '../../../service/url';
import { useNavigate } from 'react-router-dom';
import ToastNotification from '../../../components/Toast';
import { Dropdown } from 'primereact/dropdown';
import { useLocation } from 'react-router-dom';
import {validateEmail} from '../../../utilities/helpers'
import { MultiSelect } from 'primereact/multiselect';
import { toast } from 'react-toastify';
import { MODULE_ACL, FLASH_MESSAGE_ACTION_OBJECT} from '../../../utilities/constant';
import {fetchAndSetFlashMessage } from "../../../service/httpCall";



export default function CreateAgent() {
    const navigate = useNavigate();
    const location = useLocation();
    const agentData = location.state;
    const isEditMode = Boolean(agentData);

    const [agentName, setAgentName] = useState(agentData?.agent_name || '');
    const [agentNumber, setAgentNumber] = useState(agentData?.agent_number || '');
    const [selectedExtension, setSelectedExtension] = useState(
        agentData?.extension?.id || agentData?.extension || null
    );
    const [emailId, setEmailId] = useState(agentData?.email_id || '');
    const [description, setDescription] = useState(agentData?.description || '');
    const [username, setUsername] = useState(agentData?.username || '');
    const [password, setPassword] = useState('');
    const [access, setAccess] = useState(agentData?.access || null);
    const [type, setType] = useState(() =>
    Array.isArray(agentData?.type) ? agentData.type : agentData?.type ? [agentData.type] : []
    );

    const [loginStatus, setLoginStatus] = useState(agentData?.login_status || 'Inactive');

    const [extensionOptions, setExtensionOptions] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [toastProps, setToastProps] = useState({ type: 'success', message: '' });
    const [emailError, setEmailError] = useState("");
    const [agentNameError, setAgentNameError] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [notes, setNotes] = useState([]);

    const accessOptions = [
        {label: 'Select Access', value: ''},
        { label: 'Admin', value: 'Admin' },
        { label: 'Regular', value: 'Regular' },
        { label: 'Group Owner', value: 'Group Owner' },
    ];

    const typeOptions = [
        { label: 'Mobile', value: 'Mobile' },
        { label: 'Soft Phone', value: 'Soft Phone' },
        { label: 'WEBRTC', value: 'WEBRTC' },
    ];
    const loginStatusOptions = [
        { label: 'Active', value: '1' },
        { label: 'Inactive', value: '0' },
    ];

    

    // Fetch extensions for the dropdown
    useEffect(() => {
        getApiCall(API_AGENT_GROUP_EXTENSION)
            .then((data) => {
                const options = data.map((extension) => ({
                    label: extension.username,
                    value: extension.id,
                }));

                const updated = [{label: "Select Extension",
                    value: null}, ... options]
                setExtensionOptions(updated);
            })
            .catch((error) => {
                console.error('Error fetching extensions:', error);
                // setToastProps({ type: 'danger', message: 'Error fetching extensions.' });
          toast.error("Error fetching extensions.");
                setShowToast(true);
            });

        fetchAndSetFlashMessage(
        msg => msg.module_name === MODULE_ACL.AGENTS && msg.action === FLASH_MESSAGE_ACTION_OBJECT.ADD && msg.type === 'Note',
        setNotes
        );
    }, []);

    const handleSaveAgent = async () => {
        if (emailError) {
            // setToastProps({ message: "Enter correct Email", type: "danger" });
          toast.error("Enter correct Email.");
            return;
        }
        if (!validateAgentName(agentName)) {
          toast.error(agentNameError || "Agent Name validation failed");
          return;
        }
        if (!validateUsername(username)) {
          toast.error(usernameError || "Username validation failed");
          return;
        }
        if (!type || type?.length < 1) {
          toast.error("Type required");
            return;
        }
        if (!type || type?.length < 1) {
          toast.error("Type required");
            return;
        }

     
        if(Array.isArray(type)&& !(type.includes('Soft Phone') ||type.includes('WEBRTC')) && selectedExtension){
          toast.error("Extension will be allocated only in case of Type Soft Phone or Type Webrtc.");
          return
        }
        const payload = {
            agent_name: agentName,
            agent_number: Number(agentNumber),
            extension: selectedExtension ? [selectedExtension] : [],
            email_id: emailId,
            description,
            username,
            password,
            access,
            type,
            login_status: loginStatus,
        };

        try {
            if (isEditMode) {
                await postApiCall(`${API_AGENT_UPDATE}/${agentData.id}`, payload);
                // setToastProps({ type: 'success', message: 'Agent updated successfully.' });
          toast.success("Agent updated successfully");
                setShowToast(true);
                setTimeout(() => navigate('/agents'), 2000);
            } else {
                await postApiCall(AGENT_GROUP_CREATE, payload);
                // setToastProps({ type: 'success', message: 'Agent created successfully.' });
          toast.success("Agent created successfully");
                setShowToast(true);
                setTimeout(() => navigate('/agents'), 3000);
            }
        } catch (error) {
            const errorMessage =
                typeof error === "string"
                    ? error
                    : (error?.response?.data?.message || error?.message || String(error));
            const friendlyMessage = String(errorMessage).includes("Agent Number Already Exists")
                ? "Agent number must be unique. This number is already in use."
                : errorMessage;
            // setToastProps({ type: 'danger', message: errorMessage });
          toast.error(friendlyMessage);
            setShowToast(true);
        }
    };

     const handleEmailChange = (e) => {
      const value = e.target.value;
      setEmailId(value);
      setEmailError(validateEmail(value));
    };

    const validateAgentName = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setAgentNameError("Agent Name is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const nameRegex = /^[a-zA-Z0-9_]+$/;
      if (!nameRegex.test(trimmedValue)) {
        setAgentNameError("Agent Name can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setAgentNameError("");
      return true;
    };

    const validateUsername = (value) => {
      const trimmedValue = value.trim();
      if (!trimmedValue) {
        setUsernameError("Username is required");
        return false;
      }
      // Allow only letters, numbers, and underscores
      const usernameRegex = /^[a-zA-Z0-9_]+$/;
      if (!usernameRegex.test(trimmedValue)) {
        setUsernameError("Username can only contain letters, numbers, and underscores (_). No spaces or special characters allowed.");
        return false;
      }
      setUsernameError("");
      return true;
    };

    return (
        <>
            <div style={{ marginTop: '20px' }}>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-block justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">{isEditMode ? 'Edit Agent' : 'Create Agent'}</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <form>
                                    <Row className="mb-3">
                                         <div className="alert alert-warning d-flex align-items-center" role="alert">
                                                <i className="fa fa-info-circle me-2" style={{color: '#856404'}}></i>
                                                <div>
                                                    {/* Extension will be allocated only in case of Type Soft Phone or Type Webrtc. */}
                                                    <strong>Note: </strong>{notes.find(n => Number(n.priority) === 1)?.message ?? ""}
                                                </div>
                                            </div>
                                        <Col md="4">
                                            <label htmlFor="agentName" className="form-label">Agent Name <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="agentName"
                                                value={agentName}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setAgentName(value);
                                                  validateAgentName(value);
                                                }}
                                                onBlur={(e) => validateAgentName(e.target.value)}
                                                className={`form-control ${agentNameError ? 'is-invalid' : ''}`}
                                                placeholder="Agent Name"
                                                required
                                                disabled={isEditMode}
                                            />
                                            {agentNameError && <div className="invalid-feedback">{agentNameError}</div>}
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="agentNumber" className="form-label">Agent Number <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                maxLength={10}
                                                id="agentNumber"
                                                value={agentNumber}
                                                onChange={(e) => {
                                                    const val = e.target.value;
                                                    if (/^\d{0,10}$/.test(val)) {
                                                        setAgentNumber(val);
                                                    }
                                                }}
                                                className="form-control"
                                                placeholder="Agent Number"
                                                required
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="emailId" className="form-label">Email ID <span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="email"
                                                id="emailId"
                                                value={emailId}
                                                onChange={handleEmailChange}
                                                className="form-control"
                                                placeholder="Email ID"
                                                required
                                            />
                                            {emailError && <span className="text-danger">{emailError}</span>}
                                        </Col>
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="4">
                                            <label htmlFor="extensionDropdown" className="form-label">Extension</label>
                                            <Dropdown
                                                id="extensionDropdown"
                                                value={selectedExtension}
                                                style={{height:"50%",alignItems:"center"}}
                                                options={extensionOptions}
                                                onChange={(e) => setSelectedExtension(e.value)}
                                                placeholder="Select Extension"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="username" className="form-label">Username<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <input
                                                type="text"
                                                id="username"
                                                autoComplete="off"
                                                value={username}
                                                readOnly
                                                onFocus={(e) => e.target.removeAttribute("readOnly")}
                                                onChange={(e) => {
                                                  const value = e.target.value;
                                                  setUsername(value);
                                                  validateUsername(value);
                                                }}
                                                onBlur={(e) => validateUsername(e.target.value)}
                                                className={`form-control ${usernameError ? 'is-invalid' : ''}`}
                                                placeholder="Username"
                                                required
                                            />
                                            {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                                        </Col>
                                        <Col md="4">
                                            <label htmlFor="password" className="form-label">Password {!isEditMode && <span style={{ color: "red", margin: "0 4px" }}>*</span>}</label>
                                            <input
                                                type="password"
                                                id="password"
                                                value={password}
                                                autoComplete="off"
                                                readOnly
                                                onFocus={(e) => e.target.removeAttribute("readOnly")}
                                                onChange={(e) => setPassword(e.target.value)}
                                                className="form-control"
                                                placeholder={isEditMode ? "Enter new password (leave blank to keep current)" : "Password"}
                                                required={!isEditMode}
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3" style={{marginTop:"-16px"}}>
                                        <Col md="4">
                                            <label htmlFor="accessDropdown" className="form-label">Access<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                            <Dropdown
                                                id="accessDropdown"
                                                value={access}
                                                options={accessOptions}
                                                style={{height:"50%",alignItems:"center"}}
                                                onChange={(e) => setAccess(e.value)}
                                                placeholder="Select Access"
                                                className="form-control"
                                            />
                                        </Col>
                                        <Col md="5">
                                        <label htmlFor="typeDropdown" className="form-label">Type<span style={{ color: "red", margin: "0 4px" }}>*</span></label>
                                        <MultiSelect
                                            id="typeDropdown"
                                            value={type}
                                            options={
                                                selectedExtension === null
                                                ? [{ label: 'Mobile', value: 'Mobile' }]
                                                : typeOptions
                                            }
                                            onChange={(e) => setType(e.value)}
                                            placeholder="Select Type"
                                            className="form-control"
                                            display="chip" // optional: shows selected values as chips
                                            style={{ height: "50%", alignItems: "center"}}
                                            required
                                        />
                                        </Col>
                                        {/* <Col md="4">
                                            <label htmlFor="loginStatusDropdown" className="form-label">Login Status</label>
                                            <Dropdown
                                            style={{height:"50%",alignItems:"center"}}
                                                id="loginStatusDropdown"
                                                value={loginStatus}
                                                options={loginStatusOptions}
                                                onChange={(e) => setLoginStatus(e.value)}
                                                placeholder="Select Login Status"
                                                className="form-control"
                                            />
                                        </Col> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <Col md="12">
                                            <label htmlFor="description" className="form-label">Description</label>
                                            <textarea
                                                id="description"
                                                value={description}
                                                onChange={(e) => setDescription(e.target.value)}
                                                className="form-control"
                                                placeholder="Description"
                                                rows="3"
                                            ></textarea>
                                        </Col>
                                    </Row>
                                    <Button
                                        label={isEditMode ? 'Update' : 'Create'}
                                        onClick={handleSaveAgent}
                                        className="p-button-danger mt-3"
                                        type="button"
                                    />
                                </form>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
            {/* <ToastNotification show_toast={showToast} set_show_toast={setShowToast} {...toastProps} /> */}
        </>
    );
}
